import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import ReportLegend from '../ReportLegend';
import EligibilityReportSummary from './EligibilityReportSummary';
import { getReportTitle } from '../../../utils/helper';

const EligibilityReport = React.memo(({ reportData }) => {
  // Memoize title to avoid unnecessary recomputation
  const title = useMemo(
    () => getReportTitle({ reportData, reportType: "ELIGIBILITY" }),
    [reportData],
  );

  // If no reportData or summary, render nothing
  if (!reportData || !reportData.summary) return null;

  return (
    <div className="eligibility-report">
      <ReportLegend title={title} />
      <EligibilityReportSummary
        summary={reportData.summary}
        documents={reportData.documents}
      />
    </div>
  );
});

EligibilityReport.propTypes = {
  reportData: PropTypes.shape({
    summary: PropTypes.string,
  }),
};

EligibilityReport.defaultProps = {
  reportData: null,
};

export default EligibilityReport;
